import React from 'react';
import { Link, useParams } from 'react-router-dom';
import '../../assets/css/Itinerary.css';
import ForkKnifeIcon from '../../components/icons/ForkKnifeIcon';

const ItineraryAgentScreen = () => {
    const { id } = useParams(); // Get itinerary ID from URL, if applicable

    // Mock data for the itinerary (replace with actual API call based on `id`)
    const itineraryData = {
        id: id || 'ITN-001', // Use ID from URL or default
        optionName: 'Opción 1',
        destination: 'Nueva York, NY',
        dates: '19 - 21 de Julio, 2025 (3 días)',
        options: [ // Example for "Más opciones" dropdown
            { id: 'ITN-001', name: 'Opción 1', link: '/itinerary/ITN-001' },
            { id: 'ITN-002', name: 'Opción 2', link: '/itinerary/ITN-002' },
        ],
        days: [
            {
                date: 'Miércoles, 19 de Julio',
                activities: [
                    {
                        id: 'act-1', time: '6:30 a.m. (PDT)', title: 'Vuelo de SFO a JFK', status: 'Confirmado', statusClass: 'bg-success',
                        details: 'Vuelo DL 447 - Confirmación ABCDE', subDetails: 'Llegada 19/7/2025 3:02 p.m. GMT-4', iconClass: 'bi-airplane-fill', link: '#', editable: true, deletable: true,
                    },
                    {
                        id: 'act-2', time: '4:00 p.m. (EDT)', title: 'Desplazamiento al Hotel', status: 'Pendiente', statusClass: 'bg-warning text-dark',
                        details: 'Desde JFK hasta Times Square, New York, NY, USA', iconClass: 'bi-geo-alt-fill', link: '#', editable: true, deletable: true,
                    },
                    {
                        id: 'act-3', time: 'Check-in', title: 'Hilton New York Times Square', status: 'Confirmado', statusClass: 'bg-success',
                        details: '3:00 p.m. GMT-4 de entrada', subDetails: '234 W 42nd St, New York, NY 10036, USA', iconClass: 'bi-building', link: '#', editable: true, deletable: true,
                    },
                    {
                        id: 'act-4', time: '8:00 p.m. (EDT)', title: 'Cena en "The View Restaurant & Lounge"', status: 'Pendiente', statusClass: 'bg-warning text-dark',
                        details: 'Cena con vistas panorámicas', subDetails: '1535 Broadway, New York, NY 10036', iconComponent: <ForkKnifeIcon />, link: '#', editable: true, deletable: true,
                    },
                ],
            },
            {
                date: 'Jueves, 20 de Julio',
                activities: [
                    {
                        id: 'act-5', time: '10:00 a.m. (EDT)', title: 'Conferencia "Future of Tech"', status: 'Rechazada', statusClass: 'bg-danger',
                        details: 'Centro de Convenciones Javits', subDetails: '445 11th Ave, New York, NY 10001', iconClass: 'bi-laptop-fill', link: '#', editable: true, deletable: true,
                    },
                    {
                        id: 'act-6', time: '1:00 p.m. (EDT)', title: 'Almuerzo de trabajo', status: 'Pendiente', statusClass: 'bg-warning text-dark',
                        details: 'Restaurante "The Smith" Lincoln Center', subDetails: '1900 Broadway, New York, NY 10023', iconComponent: <ForkKnifeIcon />, link: '#', editable: true, deletable: true,
                    },
                    {
                        id: 'act-7', time: '4:00 p.m. (EDT)', title: 'Visita al MoMA', status: 'Confirmado', statusClass: 'bg-success',
                        details: 'Exploración de arte moderno', subDetails: '11 W 53rd St, New York, NY 10019', iconClass: 'bi-camera-fill', link: '#', editable: true, deletable: true,
                    },
                    {
                        id: 'act-8', time: '7:30 p.m. (EDT)', title: 'Cena y espectáculo de Broadway', status: 'Confirmado', statusClass: 'bg-success',
                        details: 'Cena en Joe Allen, luego "Hamilton" en Richard Rodgers Theatre', subDetails: '130 W 44th St, New York, NY 10036', iconClass: 'bi-shop-window', link: '#', editable: true, deletable: true,
                    },
                ],
            },
            {
                date: 'Viernes, 21 de Julio',
                activities: [
                    {
                        id: 'act-9', time: '11:00 a.m. (EDT)', title: 'Check-out: Hilton New York Times Square', status: 'Confirmado', statusClass: 'bg-success',
                        subDetails: '234 W 42nd St, New York, NY 10036, USA', iconClass: 'bi-building', link: '#', editable: true, deletable: true,
                    },
                    {
                        id: 'act-10', time: '12:30 p.m. (EDT)', title: 'Traslado al Aeropuerto JFK', status: 'Pendiente', statusClass: 'bg-warning text-dark',
                        details: 'Desde el hotel hacia JFK', iconClass: 'bi-bus-front-fill', link: '#', editable: true, deletable: true,
                    },
                    {
                        id: 'act-11', time: '3:00 p.m. (EDT)', title: 'Vuelo de regreso a SFO', status: 'Confirmado', statusClass: 'bg-success',
                        details: 'Vuelo DL 448 - Confirmación FGHIK', subDetails: 'Salida 21/7/2025 3:00 p.m. GMT-4', iconClass: 'bi-airplane-fill', link: '#', editable: true, deletable: true,
                    },
                ],
            },
        ],
    };

    // Placeholder functions for actions
    const handleEdit = (activityId) => {
        console.log('Edit activity with ID:', activityId);
        // Implement navigation to an edit form or open a modal
    };

    const handleDelete = (activityId) => {
        console.log('Delete activity with ID:', activityId);
        // Implement deletion logic, e.g., show confirmation dialog
    };

    return (
        <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3">
                <h1 className="h2 mb-md-0 mb-0 me-3">Itinerario de Viaje</h1>
                <Link to="/itinerary/new" className="btn btn-checkin btn-sm">
                    <i className="bi bi-plus-circle me-1"></i> Crear nueva opción
                </Link>
            </div>

            <div className="row text-start mb-4">
                <div className="col-12">
                    <div className="card card-metric border-0">
                        <div className="card-body px-md-2 px-0">
                            <div className="container-fluid header-bg">
                                <div className="container">
                                    <h3 className="mb-3 text-center">{itineraryData.optionName}</h3>
                                    <p className="mb-0"><strong>Destino:</strong> {itineraryData.destination}</p>
                                    <p className="mb-0"><strong>Fechas:</strong> {itineraryData.dates}</p>
                                    <div className="d-flex d-flex justify-content-center mt-4">
                                        <button className="btn btn-outline-secondary btn-sm me-2">
                                            <i className="bi bi-magic me-1"></i> Editar con IA
                                        </button>
                                        <div className="dropdown me-2">
                                            <button className="btn btn-outline-secondary btn-sm dropdown-toggle" type="button" id="moreOptionsDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                                <i className="bi bi-three-dots"></i> Más opciones
                                            </button>
                                            <ul className="dropdown-menu" aria-labelledby="moreOptionsDropdown">
                                                {itineraryData.options.map(option => (
                                                    <li key={option.id}>
                                                        <Link className="dropdown-item" to={option.link}>{option.name}</Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <button className="btn btn-outline-secondary btn-sm">
                                            <i className="bi bi-share me-1"></i> Compartir Itinerario
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="container py-4">
                                <div className="row">
                                    <div className="col-lg-9 mx-auto">
                                        <div className="card p-0">
                                            <div className="card-body p-0">
                                                {itineraryData.days.map((day, dayIndex) => (
                                                    <React.Fragment key={dayIndex}>
                                                        <div className="day-header">{day.date}</div>
                                                        <div className="timeline-container py-3">
                                                            <div className="timeline-line"></div>
                                                            {day.activities.map((activity, activityIndex) => (
                                                                <div className="timeline-item" key={activity.id || `${dayIndex}-${activityIndex}`}>
                                                                    <div className="timeline-icon">
                                                                        {activity.iconClass ? <i className={`bi ${activity.iconClass}`}></i> : activity.iconComponent}
                                                                    </div>
                                                                    <div className="timeline-content d-flex justify-content-between align-items-start">
                                                                        <div>
                                                                            <h6 className="mb-1">
                                                                                {activity.time && `${activity.time} - `}{activity.title}
                                                                                <span className={`badge ms-2 ${activity.statusClass}`}>{activity.status}</span>
                                                                            </h6>
                                                                            {activity.details && <p className="mb-1 text-muted">{activity.details}</p>}
                                                                            {activity.subDetails && <small>{activity.subDetails}</small>}
                                                                            {activity.link && <a href={activity.link} className="text-success small mt-2 d-block">Ver más detalles</a>}
                                                                        </div>
                                                                        <div className="d-flex flex-column justify-content-start">
                                                                            {activity.editable && (
                                                                                <button className="edit-plan-btn mb-4 text-start" onClick={() => handleEdit(activity.id || `${dayIndex}-${activityIndex}`)} title="Editar opción">
                                                                                    <i className="bi bi-pencil me-1"></i> Editar opción
                                                                                </button>
                                                                            )}
                                                                            {activity.deletable && (
                                                                                <button className="delete-plan-btn text-start" onClick={() => handleDelete(activity.id || `${dayIndex}-${activityIndex}`)} title="Quitar opción">
                                                                                    <i className="bi bi-trash me-1"></i> Quitar opción
                                                                                </button>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ItineraryAgentScreen;